"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
query getSharedTicketsByEmailPhoneNumber($email: String, $phoneNumber:String) {
  getSharedTicketsByEmailPhoneNumber(email: $email, phoneNumber:$phoneNumber ) {
        sharingData{
                firstName
                lastName
                _id
                sharing{
                   eventName
                    tickets
                    upgrades
                    _id 
                }
                   tickets {
                    name
                    seat
                }
                    upgrades {
                    name
                } 
                    userAgreement
        }

  }
}
`;
exports.default = query;
//# sourceMappingURL=getSharedTicketsByEmailPhoneNumber.query.js.map